import { isNumber } from 'underscore';
import { BriefingBlockTypeApiEnum } from '../../../api/briefings/enum/briefing-block-type-api.enum';
import { TableOfContentMentionModel } from './table-of-content-mention.model';

export class TableOfContentBlockDataModel {
    type: BriefingBlockTypeApiEnum;
    title: string;
    mentions?: TableOfContentMentionModel[];
    index: number;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    mention_count?: number;
    titleLevel: number;
    includeMentionCount?: boolean;

    constructor(
        type: BriefingBlockTypeApiEnum,
        title: string,
        mentions?: TableOfContentMentionModel[],
        index?: number,
        level?: number
    ) {
        this.type = type;

        if (title) {
            this.title = title;
        }

        if (mentions) {
            this.mentions = mentions;
        }

        if (isNumber(index)) {
            this.index = index;
        }

        this.titleLevel = level;
    }
}
